import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import type { TCreditPurposeFormFields } from 'src/client/entities/creditForm';

import { Amount, AutoBrand, AutoModel, AutoYear, InitialFee, Period, Purpose } from './ui/fields';

export interface ICreditPurposeInfoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TCreditPurposeFormFields;
}

export const FormFieldsControls: Record<keyof TCreditPurposeFormFields, React.ReactNode> = {
  autoModel: AutoModel,
  autoBrand: AutoBrand,
  autoYear: AutoYear,
  purpose: Purpose,
  amount: Amount,
  initialFee: InitialFee,
  period: Period,
};

export const FormFieldsNavigationSequence: ICreditPurposeInfoMobileConfig[] = [
  {
    fieldName: 'purpose',
    required: true,
    checkShouldMoveToNextField: true,
  },
  {
    fieldName: 'amount',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'period',
    required: true,
    checkShouldMoveToNextField: true,
  },
  {
    fieldName: 'initialFee',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'autoBrand',
    required: true,
    checkShouldMoveToNextField: true,
  },
  {
    fieldName: 'autoModel',
    required: true,
    checkShouldMoveToNextField: true,
  },
  {
    fieldName: 'autoYear',
    required: true,
    checkShouldMoveToNextField: true,
  },
];

type TFormFieldsNavigationSequenceOptions = {
  isWithoutPeriod?: boolean;
  isWithoutPurposeField?: boolean;
};

export const getFormFieldsNavigationSequence = ({
  isWithoutPeriod,
  isWithoutPurposeField,
}: TFormFieldsNavigationSequenceOptions): ICreditPurposeInfoMobileConfig[] =>
  FormFieldsNavigationSequence.filter(({ fieldName }) => {
    if (isWithoutPurposeField && fieldName === 'purpose') {
      return false;
    }

    return !(isWithoutPeriod && fieldName === 'period');
  });
